<template>
  <div v-if="loaded">
    <v-container>
      <v-row justify="center">
        <v-col
            v-if="$checkPermission('certificate_of_regular_education_button') && (this.currentSchool.canton.id === 5 || this.currentSchool.canton.id === 9)"
            cols="12"
            sm="4"
        >
          <v-btn
              depressed
              color="primary"
              block
              height="44"
              class="text-none"
              @click="openDialog"
          >
            Izradite potvrdu o redovnom školovanju
          </v-btn>
        </v-col>
        <v-spacer></v-spacer>

        <v-col cols="12">
          <v-alert v-if="regularCertificatesCount === 0" type="info" color="blue darken-1">
            Nema izrađenih potvrda o redovnom školovanju.
          </v-alert>
          <div v-else>
            <v-list-item
                v-for="regularCertificate in regularCertificates"
                :key="regularCertificate.id"
                class="px-4 px-sm-8 py-3 mb-4 flex-column flex-sm-row"
                :class="{ 'optional-subject-list': $vuetify.breakpoint.xs }"
                style="border: thin solid rgba(0, 0, 0, 0.12)"
            >
              <v-list-item-content three-line>
                <v-list-item-title
                    style="white-space: normal"
                    class="mb-3 font-weight-medium"
                >
                  <span>Potvrda se izdaje u svrhu:</span>  <v-chip color="success" class="ml-3" variant="outlined" >{{`${regularCertificate.regular_education_type.title}`}}</v-chip>
                </v-list-item-title>
                <v-list-item-subtitle>
                  <p> i u druge svrhe se ne može koristiti.</p>
                  <span class="mt-3">Datum izdavanja potvrde: <span class="primary--text ml-3">{{formatDate(regularCertificate.date_of_issue)}}</span></span>
                </v-list-item-subtitle>

              </v-list-item-content>
              <v-list-item-action class="align-self-auto">
                <v-col
                    v-if="
                    !regularCertificate.official &&
                      $checkPermission('certificates_of_regular_education delete')
                  "
                    class="pa-0"
                >
                  <v-btn
                      depressed
                      class="text-none mb-3"
                      color="error"
                      outlined
                      block
                      @click="openDelete(regularCertificate.id)"
                  >
                    <v-icon class="mr-2" size="20"> mdi-delete</v-icon>
                    Izbriši
                  </v-btn>
                </v-col>
                <v-col
                    v-if="
                    !regularCertificate.official &&
                      $checkPermission('certificates_of_regular_education edit')
                  "
                    class="pa-0"
                >
                  <v-btn
                      depressed
                      class="text-none mb-3"
                      color="primary"
                      block
                      @click="openEdit(regularCertificate)"
                  >
                    <v-icon class="mr-2" size="20"> mdi-pencil</v-icon>
                    Uredi
                  </v-btn>
                </v-col>
                <v-col class="pa-0" v-if="$checkPermission('certificates_of_regular_education read')">
                  <v-btn
                      depressed
                      class="text-none mb-3"
                      color="success"
                      block
                      target="_blank"
                      @click="goToCertificate(regularCertificate)"
                  >
                    <v-icon class="mr-2" size="20"> mdi-file-find</v-icon>
                    Pregled
                  </v-btn>
                </v-col>
              </v-list-item-action>
            </v-list-item>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        v-model="dialog"
        @click:outside="closeDialog"
    >
      <v-card>
        <v-toolbar color="primary" dark>
          <v-btn @click.native="closeDialog" dark icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ dialogTitle }}</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-toolbar-items>

            <v-btn @click.native="saveItem" color="primary" depressed large
            >Spremi
            </v-btn
            >
          </v-toolbar-items>
        </v-toolbar>

        <v-container>
          <v-row>
            <v-col>
              <ValidationProvider
                  :name="item.name"
                  :rules="item.rules"
                  mode="eager"
                  ref="provider"
                  v-bind:key="item.name"
                  v-for="item in items"
              >
                <div slot-scope="{ errors }">
                  <v-row no-gutters>
                    <!--Label for the form-->
                    <v-col
                        xs="12"
                        md="3"
                        style="height: 65px"
                        class="d-flex justify-end"
                    >
                      <div
                          class="d-flex align-center justify-end text-right mb-2"
                      >
                        <p
                            class="subtitle-3 font-weight-bold text--primary"
                            :style="{
                            color:
                              errors.length > 0
                                ? 'rgb(236 29 36) !important'
                                : '',
                            opacity: 0.8,
                            marginTop: '5px',
                            marginRight: '15px',
                          }"
                        >
                          {{ item.title }}:
                        </p>
                      </div>
                    </v-col>

                    <!-- Text field -->
                    <v-col xs="12" md="9">
                      <v-text-field
                          :ref="item.name"
                          dense
                          :name="item.name"
                          outlined
                          :type="item.type"
                          :placeholder="
                          item.rules && item.rules.includes('required')
                            ? 'Obavezno...'
                            : ''
                        "
                          :prepend-icon="item.icon"
                          v-if="item.tag === 'input'"
                          v-model="form[item.name]"
                      >
                      </v-text-field>

                      <v-textarea
                          :name="item.name"
                          outlined
                          rows="3"
                          :placeholder="
                          item.rules && item.rules.includes('required')
                            ? 'Obavezno...'
                            : ''
                        "
                          :prepend-icon="item.icon"
                          v-if="
                          item.tag === 'textarea'
                        "
                          v-model="form[item.name]"
                      >
                      </v-textarea>

                      <v-textarea
                          :name="item.name"
                          outlined
                          rows="3"
                          :placeholder="item.placeholder"
                          :prepend-icon="item.icon"
                          v-if="
                          item.tag === 'textarea'
                        "
                          v-model="form[item.name]"
                      >
                      </v-textarea>

                      <v-textarea
                          :name="item.name"
                          outlined
                          rows="3"
                          :placeholder="item.placeholder"
                          :prepend-icon="item.icon"
                          v-if="
                          item.tag === 'textarea'
                        "
                          v-model="form[item.name]"
                      >
                      </v-textarea>

                      <!-- Date picker -->
                      <v-menu
                          v-model="item.model"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                          v-if="item.tag === 'date'"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                              outlined
                              dense
                              v-model="form[item.name]"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="form[item.name]">
                        </v-date-picker>
                      </v-menu>

                      <!-- Select field -->

                      <v-autocomplete
                          outlined
                          dense
                          :placeholder="item.rules ? 'Obavezno...' : ''"
                          :items="item.source"
                          :disabled="item.disabled"
                          :name="item.name"
                          :item-text="item.text"
                          :prepend-icon="item.icon"
                          v-if="item.tag === 'select' && item.name === 'regular_education_type_id'"
                          v-model="form[item.name]"
                      >
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </div>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" width="500">
      <v-card>
        <v-card-title primary-title> Jeste li sigurni?</v-card-title>

        <v-card-text style="padding-top: 20px">
          {{ deleteText }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="deleteDialog = false" depressed large outlined
          >Odustani
          </v-btn
          >
          <v-btn @click="deleteStudentCertificate(regularCertificates.filter(d=>d.id==editIndex)[0])" color="error"
                 depressed large
          >Izbriši
          </v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="loadingDialog"
        height="400"
        width="500"
    >
      <v-card
          color="primary"
          dark
      >
        <v-card-title>Stvaranje nove potvrde</v-card-title>
        <v-card-text>
          <br>
          {{ bufferText }}
          <v-progress-linear
              v-model="value"
              :buffer-value="bufferValue"
              color="white"
              style="margin-top:30px; margin-bottom: 30px;"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import {extend, setInteractionMode, ValidationProvider} from "vee-validate";
import {digits, email, max, min, required} from "vee-validate/dist/rules";
import ApiV2 from "@/services/ApiV2";
import {serverBus} from "@/main";
import moment from "moment";

export default {
  components: {
    ValidationProvider,
  },

  props: {
    department: {
      type: Object
    }
  },
  data() {
    return {
      dialog: false,
      studentInfo: {},
      loaded: false,
      regularCertificates: [],
      regularEducationTypes: [],
      selected: {
        regular_education_type_id: null,
      },
      regularCertificatesCount: 0,
      editIndex: -1,
      odjeljenjeId: -1,
      deleteDialog: false,
      loadingDialog: false,
      form:{},
      deleteText:
          "Operacija koju ste zatražili može imati za posljedicu gubitak određenog dijela podataka. Jeste li sigurni da želite izbrisati odabrani resurs?",
      items: [
        {
          data: "regular_education_type_id",
          name: "regular_education_type_id",
          text: "type",
          options: "",
          rules: "required",
          disabled: false,
          source: [],
          tag: "select",
          title: "Svrha potvrde",
        },
        {
          data: "parish_register",
          name: "parish_register",
          options: "",
          rules: "required",
          source: [],
          tag: "input",
          type: "string",
          title: "Matična knjiga",
        },
        {
          data: "parish_register_number",
          name: "parish_register_number",
          options: "",
          rules: "required",
          source: [],
          tag: "input",
          type: "string",
          title: "Matični broj učenika",
        },
        {
          data: "docket_number",
          name: "docket_number",
          options: "",
          rules: "required",
          source: [],
          tag: "input",
          type: "text",
          title: "Urudžbeni broj",
        },

        {
          data: "date_of_issue",
          name: "date_of_issue",
          options: "",
          rules: "",
          tag: "date",
          title: "Datum ispisa",
          type: "text",
        },
      ],
    };
  },

  created() {
    setInteractionMode("eager");

    extend("min", min);
    extend("max", max);
    extend("digits", digits);
    extend("email", email);
    extend("required", {...required, message: "Ovo polje je obavezno."});

    this.odjeljenjeId = this.$route.params.odjeljenje_id
        ? this.$route.params.odjeljenje_id
        : -1;

    this.ucenikId = this.$route.params.ucenik_id
        ? this.$route.params.ucenik_id
        : -1;

    this.getCertificatesOfRegularEducationTypes()

    this.$store
        .dispatch("setEnrolledStudent", {
          departmentId: this.$route.params.odjeljenje_id,
          studentId: this.$route.params.ucenik_id,
        })
        .then(() => {
          this.getStudentRegularCertificates();
        });

  },

  async mounted() {
    await this.getStudentInfo();
  },

  computed: {

    enrolledStudent() {
      return this.$store.getters.getEnrolledStudent;
    },

    dialogTitle() {
      return this.editIndex > -1 ? "Uredite dokument" : "Dodajte dokument";
    },

    currentSchool() {
      return this.$store.getters.getSchool;
    },
    currentRole() {
      return this.$store.getters.getCurrentRole;
    },
  },

  methods: {

    formatDate(date){
      return moment(date).format("DD.MM.YYYY.");
    },

    async goToCertificate(regularCertificate) {
      let baseUrl = process.env.VUE_APP_SKOLE_API_URL;

      baseUrl = baseUrl + "v2/";

      window.open(`${baseUrl}files/${regularCertificate?.diploma_file?.uuid}`, "_blank");

    },
    async getStudentDocketNumber() {
      let {data} = await ApiV2.get(`diplomas/calculate_docket_number/${this.enrolledStudent?.id}`, {params: {semester: this.form.semester}})
      this.form.docket_number = data
      if (this.dialog) {
        this.dialog = false
        this.dialog = true
      }
    },

    async openDialog() {

      this.editIndex = -1;
      await this.getStudentDocketNumber()

      if (this.studentInfo?.user?.student_schools.length > 0) {
        let parishInfo = this.studentInfo?.user?.student_schools?.filter(x => x.school_id === parseInt(localStorage.getItem('school_id')))[0]
        this.form.parish_register = parishInfo?.parish_register
        this.form.parish_register_number = parishInfo?.parish_register_number
      }

      this.dialog = true;


    },

    openEdit(regularCertificate) {
      this.dialog = true;
      this.form = regularCertificate;
      this.editIndex = regularCertificate.id;
    },

    openDelete(regularCertificateId) {
      this.editIndex = regularCertificateId;
      this.deleteDialog = true;
    },

    closeDialog() {
      this.dialog = false;

      for (let i = 0; i < this.$refs.provider.length; i++) {
        this.$refs.provider[i].reset();
      }
    },

    getStudentRegularCertificates() {

      ApiV2.get(`department_enrollment/${this.enrolledStudent.id}/certificatesOfRegularEducation`, {
        params: {
          perPage: -1,
          with: ["diplomaFile","regularEducationType"]

        },
      })
          .then(async (response) => {
            this.regularCertificates = response.data.data;
            this.regularCertificates.map(d => d.type = 1)
            this.regularCertificatesCount = response.data.total;
          })
          .finally(() => {
            this.loaded = true;
          });

    },
    async getStudentInfo() {
      let {data} = await ApiV2.get(`departments/${this.odjeljenjeId}/departmentEnrollments`, {
            params: {
              with: ['user.studentSchools'],
              filter: {
                user_id: this.enrolledStudent?.user_id
              }
            },
          }
      )
      this.studentInfo = data.data[0];


    },
    async startBuffer() {
      this.loadingDialog = true;
      this.bufferText = 'Kreiranje dokumenta...'

      clearInterval(this.interval)

      const self = this;
      this.value = 10
      this.bufferValue = 20

      setTimeout(() => {
        self.value = 20
        this.bufferValue = 40
      }, 700)

      setTimeout(() => {
        self.value = 40
        this.bufferValue = 100
        this.bufferText = 'Generiranje pdf-a..'
      }, 1000)

      setTimeout(() => {
        self.value = 80
        this.bufferText = 'Učitavanje dokumenta..'
      }, 2000)

      setTimeout(() => {
        self.value = 100
        this.bufferText = 'Još samo trenutak..'
      }, 3000)

      setTimeout(() => {
        self.value = 101
        self.loadingDialog = false
        self.loaded = true
      }, 4000)
    },

    async createStudentCertificate() {
      this.form.department_enrollment_id = this.enrolledStudent.id;

      ApiV2.post(`regular_education`, this.form)
          .then(async () => {
            serverBus.$emit("show-snackbar", true);
            await this.startBuffer();
            this.closeDialog();
            this.getStudentRegularCertificates();
            this.form = {}
          })
          .catch((error) => {
            if (error.response.status == 422) {
              for (let key in error.response.data.errors) {
                serverBus.$emit(
                    "show-snackbar",
                    false,
                    error.response.data.errors[key][0]
                );
              }
            } else if (error.response.status == 400) {
              serverBus.$emit(
                  "show-snackbar",
                  false,
                  error.response.data.message
              );
            } else {
              serverBus.$emit("show-snackbar", false);
            }
          });
    },

    deleteStudentCertificate() {
      let apiUrl = `regular_education/${this.editIndex}`;
      ApiV2.delete(apiUrl)
          .then(() => {
            serverBus.$emit("show-snackbar", true);
            this.deleteDialog = false;
            this.getStudentRegularCertificates();
          })
          .catch(() => {
            serverBus.$emit("show-snackbar", false);
          });
    },

    updateStudentCertificate() {
      ApiV2.put(`regular_education/${this.editIndex}`, this.form)
          .then(() => {
            serverBus.$emit("show-snackbar", true);
            this.closeDialog();
            this.getStudentRegularCertificates();
            this.form = {}
          })
          .catch(() => {
            serverBus.$emit("show-snackbar", false);
          });
    },

    saveItem() {
      if (this.editIndex > -1) {
        this.updateStudentCertificate();
      } else {
        this.createStudentCertificate();
      }
    },

    getCertificatesOfRegularEducationTypes() {
      ApiV2.get(`regular_education_types`, {
        params: {
          perPage: -1,
        },
      })
          .then(response => {
            const educationTypes = response.data.data.map(item => {
              return {
                value: item.id,
                type: item.title,
              };
            });
            this.regularEducationTypes = educationTypes;

            this.items.forEach(item => {
              if (item.name === 'regular_education_type_id') {
                item.source = educationTypes;
              }
            });
          })
          .catch(error => {
            console.error('Error fetching regular education types:', error);
          })
          .finally(() => {
            this.loaded = true;
          });
    },
  },
};
</script>
